import createDuck from '../lib/MetagnosticDuck'
import {getTag, getTags } from '../lib/APIClient'

const emptyTag = { 
  _id: "", 
  name: "",
  fixed: false,
  tagType: "trips"
}

/**
 * 
 */

const duck = createDuck(
  "TAGS", 
  getTag, 
  getTags, 
  { }, 
  emptyTag, 
  null,
  { expunge: true }
)

export const createTag = duck.actions.createDoc
export const receiveTags = duck.actions.receiveCollection
export const receiveTag = duck.actions.receiveDoc
export const removeTag = duck.actions.removeDoc
export const fetchTags = duck.actions.fetchCollection
export const updateTag = duck.actions.updateDoc

export default duck

